/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BuchungsaenderungDto } from '../../models/buchungsaenderung-dto';

export interface GetAenderungenForBuchung$Json$Params {

/**
 * ID der Buchung
 */
  buchungsId: string;
}

export function getAenderungenForBuchung$Json(http: HttpClient, rootUrl: string, params: GetAenderungenForBuchung$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<BuchungsaenderungDto>>> {
  const rb = new RequestBuilder(rootUrl, getAenderungenForBuchung$Json.PATH, 'get');
  if (params) {
    rb.path('buchungsId', params.buchungsId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<BuchungsaenderungDto>>;
    })
  );
}

getAenderungenForBuchung$Json.PATH = '/v1/buchungen/{buchungsId}/aenderungen';
